/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_Media_UploadInputs */

const cs_social_export_media_upload = /** @type {(inputs: Social_Export_Media_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vlastní média`)
};

const en_social_export_media_upload = /** @type {(inputs: Social_Export_Media_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom media`)
};

/**
* | output |
* | --- |
* | "Custom media" |
*
* @param {Social_Export_Media_UploadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_media_upload = /** @type {((inputs?: Social_Export_Media_UploadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_Media_UploadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_media_upload(inputs)
	return cs_social_export_media_upload(inputs)
});